module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      checked: _vm.listItem.checked
    }
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        _vm.checkOffListItem(_vm.index)
      }
    }
  }, [_vm._v(_vm._s(_vm.icon))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.listItem.quantity))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.listItem.name))]), _vm._v(" "), (_vm.editMode && !_vm.listItem.checked) ? _c('i', {
    staticClass: "material-icons pull-right",
    on: {
      "click": function($event) {
        _vm.deleteListItem(_vm.index)
      }
    }
  }, [_vm._v("close")]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.listItem.checked) ? _c('i', {
    staticClass: "material-icons pull-right item-increase",
    on: {
      "click": function($event) {
        _vm.increaseListItem(_vm.index)
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.listItem.checked) ? _c('i', {
    staticClass: "material-icons pull-right item-decrease",
    on: {
      "click": function($event) {
        _vm.decreaseListItem(_vm.index)
      }
    }
  }, [_vm._v("remove")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-183db6b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListItem.vue
// module id = 129
// module chunks = 0